<div class="error-panel-content-container">
  <span class="main-message h3">{{ error ? _mainErrorMessage : _mainMessage }}</span>
  <span class="sub-message p">{{ error ? _subErrorMessage : _subMessage }}</span>
  <i [ngClass]="error ? iconErrorClass : iconClass" class="icon"></i>
  <app-button *ngIf="showReloadButton" id="error-panel-reload-button" type="secondary" (activated)="reload.emit()">
    <span>{{reloadButtonText}}</span>
  </app-button>
</div>
